import { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router';
import {
    Alert, Box, Button, Card, FormControl, FormLabel, Input, Link, Stack, Typography,
} from '@mui/joy';
import { motion } from 'framer-motion';

import { APIBusinessRegister } from '../../api_business_auth';
import { getStoredRef } from '../../refStore';
import { NAME_PROJECT } from '../../utils';

export default function BusinessRegisterPage() {
    const [form, setForm] = useState({ company_name: '', email: '', password: '', contact_name: '', phone: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    const submit = async () => {
        setError(null);
        if (!form.company_name.trim() || !form.email.trim() || !form.password) {
            setError('Название компании, email и пароль обязательны'); return;
        }
        setLoading(true);
        try {
            const payload = {};
            Object.entries(form).forEach(([k, v]) => { if (v && v.trim()) payload[k] = v.trim(); });
            const ref = getStoredRef();
            if (ref) payload.ref = ref;
            await APIBusinessRegister(payload);
            setDone(true);
        } catch (e) {
            setError(e?.response?.data?.error || 'Не удалось зарегистрироваться');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center',
            px: 2, py: 4,
            background: (t) => `linear-gradient(145deg, ${t.vars.palette.primary[50]} 0%, #fff 100%)`,
        }}>
            <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.25 }} style={{ width: '100%', maxWidth: 460 }}>
                <Card sx={{ p: 3, borderRadius: 'xl', boxShadow: 'lg', background: 'rgba(255,255,255,0.9)' }}>
                    <Typography level="h3" sx={{ mb: 0.5, color: 'primary.700' }}>Регистрация</Typography>
                    <Typography level="body-sm" color="neutral" sx={{ mb: 2 }}>
                        {NAME_PROJECT} · кабинет рекламодателя
                    </Typography>

                    {done ? (
                        <Alert color="success">
                            Письмо с подтверждением отправлено на {form.email}. Откройте ссылку из письма,
                            затем войдите.{' '}
                            <Link component={RouterLink} to="/business/login">Перейти ко входу</Link>
                        </Alert>
                    ) : (
                        <>
                            {error && <Alert color="danger" sx={{ mb: 1.5 }}>{error}</Alert>}
                            <Stack spacing={1.5}>
                                <FormControl>
                                    <FormLabel>Название компании *</FormLabel>
                                    <Input value={form.company_name}
                                           onChange={(e) => setForm({ ...form, company_name: e.target.value })} />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Email *</FormLabel>
                                    <Input type="email" value={form.email}
                                           onChange={(e) => setForm({ ...form, email: e.target.value })} />
                                </FormControl>
                                <FormControl>
                                    <FormLabel>Пароль * (мин. 8 символов, буквы и цифры)</FormLabel>
                                    <Input type="password" value={form.password}
                                           onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                </FormControl>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                                    <FormControl sx={{ flex: 1 }}>
                                        <FormLabel>Контактное лицо</FormLabel>
                                        <Input value={form.contact_name}
                                               onChange={(e) => setForm({ ...form, contact_name: e.target.value })} />
                                    </FormControl>
                                    <FormControl sx={{ flex: 1 }}>
                                        <FormLabel>Телефон</FormLabel>
                                        <Input value={form.phone}
                                               onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                                    </FormControl>
                                </Stack>
                                <Button onClick={submit} loading={loading} size="lg">Зарегистрироваться</Button>
                            </Stack>
                            <Box sx={{ mt: 2, textAlign: 'center' }}>
                                <Link component={RouterLink} to="/business/login" level="body-sm">← Ко входу</Link>
                            </Box>
                        </>
                    )}
                </Card>
            </motion.div>
        </Box>
    );
}